// extracted by mini-css-extract-plugin
export default {"hoverText":"BubbleText_hoverText__8zLou"};